export default __webpack_public_path__ + "static/media/07_bag-2.7c3e926f.jpg";